import repPayFilterSlice from './independantRepPayFilter-slice';

export const { setIReUsersFilters, resetState, resetIRUsersFiltersState } = repPayFilterSlice.actions;
